"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _asyncResourceModel = require("./asyncResourceModel");

function asyncResource(reducer, opts) {
  var initialState = (0, _asyncResourceModel.createModel)({
    data: reducer(undefined, {})
  });
  var requestActions = opts.requestActions,
      responseActions = opts.responseActions,
      _opts$invalidatingAct = opts.invalidatingActions,
      invalidatingActions = _opts$invalidatingAct === void 0 ? [] : _opts$invalidatingAct,
      _opts$customActions = opts.customActions,
      customActions = _opts$customActions === void 0 ? [] : _opts$customActions;

  var wrappedAsyncResource = function wrappedAsyncResource() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var type = action.type,
        actionError = action.error;
    var data = state.getData();
    var internalState = state._internalState;

    if (requestActions.indexOf(type) >= 0) {
      // Request made
      return state.set('_internalState', internalState.set('loading', true));
    } else if (responseActions.indexOf(type) >= 0) {
      if (actionError) {
        var errorMap;

        if (action.payload instanceof XMLHttpRequest) {
          // Support earlyFetch requests
          var parsedJson = {};

          try {
            parsedJson = JSON.parse(action.payload.responseText);
          } catch (e) {
            /* Ignore failures */
          }

          errorMap = (0, _immutable.Map)({
            responseJSON: parsedJson,
            status: action.payload.status
          });
        } else {
          errorMap = (0, _immutable.Map)((0, _immutable.fromJS)(action.payload));
        } // Request failed


        return state.set('_internalState', internalState.merge({
          data: reducer(data, action),
          loading: false,
          error: true,
          errorStatus: errorMap.get('status', null),
          errorType: errorMap.get(['responseJSON', 'errorType'], null),
          errorTokens: errorMap.get(['responseJSON', 'errorTokens'], null)
        }));
      } // Request succeeded


      return state.set('_internalState', internalState.merge({
        data: reducer(data, action),
        dirty: false,
        error: false,
        errorStatus: null,
        errorType: null,
        errorTokens: null,
        loading: false,
        lastLoaded: new Date().valueOf()
      }));
    } else if (invalidatingActions.indexOf(type) >= 0) {
      return state.set('_internalState', internalState.merge({
        dirty: true,
        data: reducer(data, action)
      }));
    } else if (customActions.indexOf(type) >= 0) {
      var result = reducer(data, action);

      if ((0, _immutable.is)(result, data)) {
        // Same result from reducer
        return state;
      }

      return state.set('_internalState', internalState.merge({
        data: result
      }));
    } // Else: Unrelated action, do not run reducer


    return state;
  };

  return wrappedAsyncResource;
}

var _default = asyncResource;
exports.default = _default;
module.exports = exports.default;